/* src/app/features/tarefas/honra/tarefas-honra.component.scss */
h5 {
  margin-bottom: 40px;
}
.submit.col-auto {
  margin-top: 20px;
}
.d-flex.title {
  padding-right: 517px;
  font-weight: bold;
}
.d-flex.title2 {
  padding-right: 660px;
  font-weight: bold;
}
.d-flex.title3 {
  padding-right: 821px;
  font-weight: bold;
}
.d-flex.title4 {
  padding-right: 732px;
  font-weight: bold;
}
.d-flex.title5 {
  padding-right: 589px;
  font-weight: bold;
}
.d-flex.title6 {
  padding-right: 622px;
  font-weight: bold;
}
.d-flex.title7 {
  padding-right: 803px;
  font-weight: bold;
}
.d-flex.title8 {
  padding-right: 721px;
  font-weight: bold;
}
.d-flex.title9 {
  padding-right: 730px;
  font-weight: bold;
}
.d-flex.title10 {
  padding-right: 578px;
  font-weight: bold;
}
.d-flex.title11 {
  padding-right: 703px;
  font-weight: bold;
}
.d-flex.title12 {
  padding-right: 751px;
  font-weight: bold;
}
.d-flex.title13 {
  padding-right: 693px;
  font-weight: bold;
}
.d-flex.title14 {
  padding-right: 767px;
  font-weight: bold;
}
.d-flex.emitirFaturas {
  padding-right: 844px;
  font-weight: bold;
}
.d-flex.emitirRelarioProvPag {
  padding-right: 662px;
  font-weight: bold;
}
.d-flex.emitirRelatorioDefin {
  padding-right: 776px;
  font-weight: bold;
}
/*# sourceMappingURL=tarefas-honra.component.css.map */
